import { Component, Input } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent {
  @Input() invoiceData;

  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = true;
  }

}
